import _asyncToGenerator from "C:/GitLab-Runner/builds/VgMjNYji/0/billing/billingmalta/src/frontend/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { AbstractBreezeViewComponent } from '@common/classes/breeze-view';
import { EventTypeCodes, VesselVisitStatusCodes } from '@common/classes/codes';
import { VTSPermissions } from '@common/classes/permissions';
import { NmswChargeCandidatesModalComponent } from '@common/components/nmsw-charge-candidates-modal/nmsw-charge-candidates-modal.component';
import { BreezeViewService } from '@common/services/breeze-view.service';
import { DialogService } from '@common/services/dialog.service';
import { environment } from '@environments/environment';
import { AddExistingInvoiceModalComponent } from '@vessel-visit/components/add-existing-invoice-modal/add-existing-invoice-modal.component';
import { AppControlType } from '../app-control/app-control.component';
import { chargeCandidateFilters, ToggleableFilterComponent } from '../toggleable-filter/toggleable-filter.component';
import * as i0 from "@angular/core";
import * as i1 from "@common/services/breeze-view.service";
import * as i2 from "@common/services/dialog.service";
import * as i3 from "@angular/common";
import * as i4 from "@angular/router";
import * as i5 from "@angular/forms";
import * as i6 from "@fortawesome/angular-fontawesome";
import * as i7 from "@ngx-translate/core";
import * as i8 from "@progress/kendo-angular-grid";
import * as i9 from "@progress/kendo-angular-layout";
import * as i10 from "../action-bar/action-bar.component";
import * as i11 from "../app-control/app-control.component";
import * as i12 from "../loader/loader.component";
import * as i13 from "../content-link-header/content-link-header.component";
import * as i14 from "../app-grid/app-grid.component";
import * as i15 from "../note-list/note-list.component";
import * as i16 from "../editable-grid/editable-grid.component";
import * as i17 from "../flag-icon.component";
import * as i18 from "../check-icon.component";
import * as i19 from "../toggleable-filter/toggleable-filter.component";
import * as i20 from "../popover-list/popover-list.component";
import * as i21 from "../bookmark/bookmark.component";
import * as i22 from "../invoice-list/invoice-list.component";
import * as i23 from "../vessel-permit-detail/vessel-permit-detail.component";
import * as i24 from "../vessel-revision-change-applicator/vessel-revision-change-applicator.component";
import * as i25 from "../../pipes/codelist.pipe";
function NmswVesselVisitViewComponent_app_action_bar_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-action-bar", 13);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("items", ctx_r0.actionBar);
  }
}
const _c0 = function (a0, a1) {
  return {
    current: a0,
    revised: a1
  };
};
function NmswVesselVisitViewComponent_ng_template_2_app_vessel_revision_change_applicator_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r55 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-vessel-revision-change-applicator", 57);
    i0.ɵɵlistener("applyVesselRevision", function NmswVesselVisitViewComponent_ng_template_2_app_vessel_revision_change_applicator_2_Template_app_vessel_revision_change_applicator_applyVesselRevision_0_listener($event) {
      i0.ɵɵrestoreView(_r55);
      const ctx_r54 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r54.applyVesselRevision($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("vesselRevisions", i0.ɵɵpureFunction2(1, _c0, ctx_r24.model == null ? null : ctx_r24.model.vesselRevision, ctx_r24.revisions.at(-1)));
  }
}
function NmswVesselVisitViewComponent_ng_template_2_app_control_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r57 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 58);
    i0.ɵɵlistener("ngModelChange", function NmswVesselVisitViewComponent_ng_template_2_app_control_7_Template_app_control_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r57);
      const ctx_r56 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r56.model.vesselRevision.vesselId = $event);
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(1, 3, "Vessel"))("ngModel", ctx_r25.model.vesselRevision.vesselId)("entity", ctx_r25.model.vesselRevision);
  }
}
function NmswVesselVisitViewComponent_ng_template_2_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r59 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 59);
    i0.ɵɵlistener("ngModelChange", function NmswVesselVisitViewComponent_ng_template_2_ng_template_8_Template_app_control_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r59);
      const ctx_r58 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r58.model.vtsVesselId = $event);
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(1, 3, "Vessel"))("ngModel", ctx_r27.model.vtsVesselId)("entity", ctx_r27.model);
  }
}
function NmswVesselVisitViewComponent_ng_template_2_app_control_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r61 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 60);
    i0.ɵɵlistener("ngModelChange", function NmswVesselVisitViewComponent_ng_template_2_app_control_11_Template_app_control_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r61);
      const ctx_r60 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r60.model.vesselRevision.iMONumber = $event);
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(1, 3, "IMO Number"))("ngModel", ctx_r28.model.vesselRevision.iMONumber)("entity", ctx_r28.model.vesselRevision);
  }
}
function NmswVesselVisitViewComponent_ng_template_2_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r63 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 60);
    i0.ɵɵlistener("ngModelChange", function NmswVesselVisitViewComponent_ng_template_2_ng_template_12_Template_app_control_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r63);
      const ctx_r62 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r62.model.vtsVessel.iMONumber = $event);
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(1, 3, "IMO Number"))("ngModel", ctx_r30.model.vtsVessel.iMONumber)("entity", ctx_r30.model.vtsVessel);
  }
}
function NmswVesselVisitViewComponent_ng_template_2_app_control_28_Template(rf, ctx) {
  if (rf & 1) {
    const _r65 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 61);
    i0.ɵɵlistener("ngModelChange", function NmswVesselVisitViewComponent_ng_template_2_app_control_28_Template_app_control_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r65);
      const ctx_r64 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r64.model.vesselRevision.countryId = $event);
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r31 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(1, 3, "Flag"))("ngModel", ctx_r31.model.vesselRevision.countryId)("entity", ctx_r31.model.vesselRevision);
  }
}
function NmswVesselVisitViewComponent_ng_template_2_ng_template_29_Template(rf, ctx) {
  if (rf & 1) {
    const _r67 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 61);
    i0.ɵɵlistener("ngModelChange", function NmswVesselVisitViewComponent_ng_template_2_ng_template_29_Template_app_control_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r67);
      const ctx_r66 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r66.model.vtsVessel.countryId = $event);
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r33 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(1, 3, "Flag"))("ngModel", ctx_r33.model.vtsVessel.countryId)("entity", ctx_r33.model.vtsVessel);
  }
}
function NmswVesselVisitViewComponent_ng_template_2_app_control_38_Template(rf, ctx) {
  if (rf & 1) {
    const _r69 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 62);
    i0.ɵɵlistener("ngModelChange", function NmswVesselVisitViewComponent_ng_template_2_app_control_38_Template_app_control_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r69);
      const ctx_r68 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r68.model.vesselRevision.grossTonnage = $event);
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r34 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(1, 4, "GRT"))("decimals", 3)("ngModel", ctx_r34.model.vesselRevision.grossTonnage)("entity", ctx_r34.model.vesselRevision);
  }
}
function NmswVesselVisitViewComponent_ng_template_2_app_control_40_Template(rf, ctx) {
  if (rf & 1) {
    const _r71 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 63);
    i0.ɵɵlistener("ngModelChange", function NmswVesselVisitViewComponent_ng_template_2_app_control_40_Template_app_control_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r71);
      const ctx_r70 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r70.model.vesselRevision.netTonnage = $event);
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r35 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(1, 3, "NRT"))("ngModel", ctx_r35.model.vesselRevision.netTonnage)("entity", ctx_r35.model.vesselRevision);
  }
}
function NmswVesselVisitViewComponent_ng_template_2_app_control_42_Template(rf, ctx) {
  if (rf & 1) {
    const _r73 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 64);
    i0.ɵɵlistener("ngModelChange", function NmswVesselVisitViewComponent_ng_template_2_app_control_42_Template_app_control_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r73);
      const ctx_r72 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r72.model.vesselRevision.length = $event);
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r36 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(1, 3, "LOA"))("ngModel", ctx_r36.model.vesselRevision.length)("entity", ctx_r36.model.vesselRevision);
  }
}
function NmswVesselVisitViewComponent_ng_template_2_ng_template_43_Template(rf, ctx) {
  if (rf & 1) {
    const _r75 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 64);
    i0.ɵɵlistener("ngModelChange", function NmswVesselVisitViewComponent_ng_template_2_ng_template_43_Template_app_control_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r75);
      const ctx_r74 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r74.model.vtsVessel.length = $event);
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r38 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(1, 3, "LOA"))("ngModel", ctx_r38.model.vtsVessel.length)("entity", ctx_r38.model.vtsVessel);
  }
}
function NmswVesselVisitViewComponent_ng_template_2_app_control_72_Template(rf, ctx) {
  if (rf & 1) {
    const _r77 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 65);
    i0.ɵɵlistener("ngModelChange", function NmswVesselVisitViewComponent_ng_template_2_app_control_72_Template_app_control_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r77);
      const ctx_r76 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r76.model.vesselRevision.typeId = $event);
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r39 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(1, 3, "Vessel Type"))("ngModel", ctx_r39.model.vesselRevision.typeId)("entity", ctx_r39.model.vesselRevision);
  }
}
function NmswVesselVisitViewComponent_ng_template_2_ng_template_73_Template(rf, ctx) {
  if (rf & 1) {
    const _r79 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 65);
    i0.ɵɵlistener("ngModelChange", function NmswVesselVisitViewComponent_ng_template_2_ng_template_73_Template_app_control_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r79);
      const ctx_r78 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r78.model.vtsVessel.typeId = $event);
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r41 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(1, 3, "Vessel Type"))("ngModel", ctx_r41.model.vtsVessel.typeId)("entity", ctx_r41.model.vtsVessel);
  }
}
function NmswVesselVisitViewComponent_ng_template_2_ng_template_89_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function NmswVesselVisitViewComponent_ng_template_2_ng_template_89_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NmswVesselVisitViewComponent_ng_template_2_ng_template_89_ng_container_0_Template, 1, 0, "ng-container", 66);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r2 = i0.ɵɵreference(4);
    i0.ɵɵproperty("ngTemplateOutlet", _r2);
  }
}
function NmswVesselVisitViewComponent_ng_template_2_ng_template_92_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function NmswVesselVisitViewComponent_ng_template_2_ng_template_92_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NmswVesselVisitViewComponent_ng_template_2_ng_template_92_ng_container_0_Template, 1, 0, "ng-container", 66);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r4 = i0.ɵɵreference(6);
    i0.ɵɵproperty("ngTemplateOutlet", _r4);
  }
}
function NmswVesselVisitViewComponent_ng_template_2_ng_template_95_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function NmswVesselVisitViewComponent_ng_template_2_ng_template_95_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NmswVesselVisitViewComponent_ng_template_2_ng_template_95_ng_container_0_Template, 1, 0, "ng-container", 66);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r6 = i0.ɵɵreference(8);
    i0.ɵɵproperty("ngTemplateOutlet", _r6);
  }
}
function NmswVesselVisitViewComponent_ng_template_2_ng_template_98_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function NmswVesselVisitViewComponent_ng_template_2_ng_template_98_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NmswVesselVisitViewComponent_ng_template_2_ng_template_98_ng_container_0_Template, 1, 0, "ng-container", 66);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r8 = i0.ɵɵreference(10);
    i0.ɵɵproperty("ngTemplateOutlet", _r8);
  }
}
function NmswVesselVisitViewComponent_ng_template_2_ng_template_101_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function NmswVesselVisitViewComponent_ng_template_2_ng_template_101_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NmswVesselVisitViewComponent_ng_template_2_ng_template_101_ng_container_0_Template, 1, 0, "ng-container", 66);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r10 = i0.ɵɵreference(12);
    i0.ɵɵproperty("ngTemplateOutlet", _r10);
  }
}
function NmswVesselVisitViewComponent_ng_template_2_ng_template_104_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function NmswVesselVisitViewComponent_ng_template_2_ng_template_104_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NmswVesselVisitViewComponent_ng_template_2_ng_template_104_ng_container_0_Template, 1, 0, "ng-container", 66);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r12 = i0.ɵɵreference(14);
    i0.ɵɵproperty("ngTemplateOutlet", _r12);
  }
}
function NmswVesselVisitViewComponent_ng_template_2_ng_template_107_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function NmswVesselVisitViewComponent_ng_template_2_ng_template_107_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NmswVesselVisitViewComponent_ng_template_2_ng_template_107_ng_container_0_Template, 1, 0, "ng-container", 66);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r14 = i0.ɵɵreference(16);
    i0.ɵɵproperty("ngTemplateOutlet", _r14);
  }
}
function NmswVesselVisitViewComponent_ng_template_2_ng_template_110_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function NmswVesselVisitViewComponent_ng_template_2_ng_template_110_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NmswVesselVisitViewComponent_ng_template_2_ng_template_110_ng_container_0_Template, 1, 0, "ng-container", 66);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r16 = i0.ɵɵreference(18);
    i0.ɵɵproperty("ngTemplateOutlet", _r16);
  }
}
function NmswVesselVisitViewComponent_ng_template_2_ng_template_113_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function NmswVesselVisitViewComponent_ng_template_2_ng_template_113_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NmswVesselVisitViewComponent_ng_template_2_ng_template_113_ng_container_0_Template, 1, 0, "ng-container", 66);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r18 = i0.ɵɵreference(20);
    i0.ɵɵproperty("ngTemplateOutlet", _r18);
  }
}
function NmswVesselVisitViewComponent_ng_template_2_ng_template_116_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function NmswVesselVisitViewComponent_ng_template_2_ng_template_116_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NmswVesselVisitViewComponent_ng_template_2_ng_template_116_ng_container_0_Template, 1, 0, "ng-container", 66);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r20 = i0.ɵɵreference(22);
    i0.ɵɵproperty("ngTemplateOutlet", _r20);
  }
}
function NmswVesselVisitViewComponent_ng_template_2_ng_template_119_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function NmswVesselVisitViewComponent_ng_template_2_ng_template_119_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NmswVesselVisitViewComponent_ng_template_2_ng_template_119_ng_container_0_Template, 1, 0, "ng-container", 66);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r22 = i0.ɵɵreference(24);
    i0.ɵɵproperty("ngTemplateOutlet", _r22);
  }
}
function NmswVesselVisitViewComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r92 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-content-link-header", 14)(1, "app-bookmark", 15);
    i0.ɵɵlistener("setColor", function NmswVesselVisitViewComponent_ng_template_2_Template_app_bookmark_setColor_1_listener($event) {
      i0.ɵɵrestoreView(_r92);
      const ctx_r91 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r91.setBookmarkColor($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, NmswVesselVisitViewComponent_ng_template_2_app_vessel_revision_change_applicator_2_Template, 1, 4, "app-vessel-revision-change-applicator", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 17)(4, "div", 18)(5, "div", 19)(6, "div", 20);
    i0.ɵɵtemplate(7, NmswVesselVisitViewComponent_ng_template_2_app_control_7_Template, 2, 5, "app-control", 21);
    i0.ɵɵtemplate(8, NmswVesselVisitViewComponent_ng_template_2_ng_template_8_Template, 2, 5, "ng-template", null, 22, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 20);
    i0.ɵɵtemplate(11, NmswVesselVisitViewComponent_ng_template_2_app_control_11_Template, 2, 5, "app-control", 23);
    i0.ɵɵtemplate(12, NmswVesselVisitViewComponent_ng_template_2_ng_template_12_Template, 2, 5, "ng-template", null, 24, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 20)(15, "app-control", 25);
    i0.ɵɵlistener("ngModelChange", function NmswVesselVisitViewComponent_ng_template_2_Template_app_control_ngModelChange_15_listener($event) {
      i0.ɵɵrestoreView(_r92);
      const ctx_r93 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r93.model.portId = $event);
    });
    i0.ɵɵpipe(16, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(17, "div", 20)(18, "app-control", 26);
    i0.ɵɵlistener("ngModelChange", function NmswVesselVisitViewComponent_ng_template_2_Template_app_control_ngModelChange_18_listener($event) {
      i0.ɵɵrestoreView(_r92);
      const ctx_r94 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r94.model.berthId = $event);
    });
    i0.ɵɵpipe(19, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(20, "div", 20)(21, "app-control", 27);
    i0.ɵɵlistener("ngModelChange", function NmswVesselVisitViewComponent_ng_template_2_Template_app_control_ngModelChange_21_listener($event) {
      i0.ɵɵrestoreView(_r92);
      const ctx_r95 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r95.model.ata = $event);
    });
    i0.ɵɵpipe(22, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(23, "div", 20)(24, "app-control", 28);
    i0.ɵɵlistener("ngModelChange", function NmswVesselVisitViewComponent_ng_template_2_Template_app_control_ngModelChange_24_listener($event) {
      i0.ɵɵrestoreView(_r92);
      const ctx_r96 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r96.model.atd = $event);
    });
    i0.ɵɵpipe(25, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(26, "div", 19)(27, "div", 20);
    i0.ɵɵtemplate(28, NmswVesselVisitViewComponent_ng_template_2_app_control_28_Template, 2, 5, "app-control", 29);
    i0.ɵɵtemplate(29, NmswVesselVisitViewComponent_ng_template_2_ng_template_29_Template, 2, 5, "ng-template", null, 30, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(31, "div", 20)(32, "app-control", 31);
    i0.ɵɵlistener("ngModelChange", function NmswVesselVisitViewComponent_ng_template_2_Template_app_control_ngModelChange_32_listener($event) {
      i0.ɵɵrestoreView(_r92);
      const ctx_r97 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r97.model.lastPortId = $event);
    });
    i0.ɵɵpipe(33, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(34, "div", 20)(35, "app-control", 32);
    i0.ɵɵlistener("ngModelChange", function NmswVesselVisitViewComponent_ng_template_2_Template_app_control_ngModelChange_35_listener($event) {
      i0.ɵɵrestoreView(_r92);
      const ctx_r98 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r98.model.nextPortId = $event);
    });
    i0.ɵɵpipe(36, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(37, "div", 20);
    i0.ɵɵtemplate(38, NmswVesselVisitViewComponent_ng_template_2_app_control_38_Template, 2, 6, "app-control", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(39, "div", 20);
    i0.ɵɵtemplate(40, NmswVesselVisitViewComponent_ng_template_2_app_control_40_Template, 2, 5, "app-control", 34);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(41, "div", 20);
    i0.ɵɵtemplate(42, NmswVesselVisitViewComponent_ng_template_2_app_control_42_Template, 2, 5, "app-control", 35);
    i0.ɵɵtemplate(43, NmswVesselVisitViewComponent_ng_template_2_ng_template_43_Template, 2, 5, "ng-template", null, 36, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(45, "div", 19)(46, "div", 37)(47, "app-control", 38);
    i0.ɵɵlistener("ngModelChange", function NmswVesselVisitViewComponent_ng_template_2_Template_app_control_ngModelChange_47_listener($event) {
      i0.ɵɵrestoreView(_r92);
      const ctx_r99 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r99.model.agentId = $event);
    });
    i0.ɵɵpipe(48, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(49, "div", 37)(50, "app-control", 39);
    i0.ɵɵlistener("ngModelChange", function NmswVesselVisitViewComponent_ng_template_2_Template_app_control_ngModelChange_50_listener($event) {
      i0.ɵɵrestoreView(_r92);
      const ctx_r100 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r100.model.additionalAgents = $event);
    });
    i0.ɵɵpipe(51, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(52, "div", 37)(53, "app-control", 40);
    i0.ɵɵlistener("ngModelChange", function NmswVesselVisitViewComponent_ng_template_2_Template_app_control_ngModelChange_53_listener($event) {
      i0.ɵɵrestoreView(_r92);
      const ctx_r101 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r101.model.vtsCallPurposeId = $event);
    });
    i0.ɵɵpipe(54, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(55, "div", 37)(56, "app-control", 41);
    i0.ɵɵlistener("ngModelChange", function NmswVesselVisitViewComponent_ng_template_2_Template_app_control_ngModelChange_56_listener($event) {
      i0.ɵɵrestoreView(_r92);
      const ctx_r102 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r102.model.callActivityId = $event);
    });
    i0.ɵɵpipe(57, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(58, "div", 42)(59, "app-control", 43);
    i0.ɵɵlistener("ngModelChange", function NmswVesselVisitViewComponent_ng_template_2_Template_app_control_ngModelChange_59_listener($event) {
      i0.ɵɵrestoreView(_r92);
      const ctx_r103 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r103.model.callPurposes = $event);
    });
    i0.ɵɵpipe(60, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(61, "div", 19)(62, "div", 20)(63, "app-control", 44);
    i0.ɵɵlistener("ngModelChange", function NmswVesselVisitViewComponent_ng_template_2_Template_app_control_ngModelChange_63_listener($event) {
      i0.ɵɵrestoreView(_r92);
      const ctx_r104 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r104.model.mswVisitNumber = $event);
    });
    i0.ɵɵpipe(64, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(65, "div", 20)(66, "app-control", 45);
    i0.ɵɵlistener("ngModelChange", function NmswVesselVisitViewComponent_ng_template_2_Template_app_control_ngModelChange_66_listener($event) {
      i0.ɵɵrestoreView(_r92);
      const ctx_r105 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r105.model.visitNumber = $event);
    });
    i0.ɵɵpipe(67, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(68, "div", 20)(69, "app-control", 46);
    i0.ɵɵlistener("ngModelChange", function NmswVesselVisitViewComponent_ng_template_2_Template_app_control_ngModelChange_69_listener($event) {
      i0.ɵɵrestoreView(_r92);
      const ctx_r106 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r106.model.statusId = $event);
    });
    i0.ɵɵpipe(70, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(71, "div", 20);
    i0.ɵɵtemplate(72, NmswVesselVisitViewComponent_ng_template_2_app_control_72_Template, 2, 5, "app-control", 47);
    i0.ɵɵtemplate(73, NmswVesselVisitViewComponent_ng_template_2_ng_template_73_Template, 2, 5, "ng-template", null, 48, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(75, "div", 20)(76, "app-control", 49);
    i0.ɵɵlistener("ngModelChange", function NmswVesselVisitViewComponent_ng_template_2_Template_app_control_ngModelChange_76_listener($event) {
      i0.ɵɵrestoreView(_r92);
      const ctx_r107 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r107.model.arrivalCallPurposeRemarks = $event);
    });
    i0.ɵɵpipe(77, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(78, "div", 20)(79, "app-control", 50);
    i0.ɵɵlistener("ngModelChange", function NmswVesselVisitViewComponent_ng_template_2_Template_app_control_ngModelChange_79_listener($event) {
      i0.ɵɵrestoreView(_r92);
      const ctx_r108 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r108.model.departureRemarks = $event);
    });
    i0.ɵɵpipe(80, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(81, "div", 19)(82, "div", 51)(83, "app-control", 52);
    i0.ɵɵlistener("ngModelChange", function NmswVesselVisitViewComponent_ng_template_2_Template_app_control_ngModelChange_83_listener($event) {
      i0.ɵɵrestoreView(_r92);
      const ctx_r109 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r109.model.isShort = $event);
    });
    i0.ɵɵpipe(84, "translate");
    i0.ɵɵelementEnd()()()()();
    i0.ɵɵelementStart(85, "kendo-tabstrip", 53, 54);
    i0.ɵɵlistener("tabSelect", function NmswVesselVisitViewComponent_ng_template_2_Template_kendo_tabstrip_tabSelect_85_listener($event) {
      i0.ɵɵrestoreView(_r92);
      const ctx_r110 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r110.tabSelected($event));
    });
    i0.ɵɵelementStart(87, "kendo-tabstrip-tab", 55);
    i0.ɵɵpipe(88, "translate");
    i0.ɵɵtemplate(89, NmswVesselVisitViewComponent_ng_template_2_ng_template_89_Template, 1, 1, "ng-template", 56);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(90, "kendo-tabstrip-tab", 55);
    i0.ɵɵpipe(91, "translate");
    i0.ɵɵtemplate(92, NmswVesselVisitViewComponent_ng_template_2_ng_template_92_Template, 1, 1, "ng-template", 56);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(93, "kendo-tabstrip-tab", 55);
    i0.ɵɵpipe(94, "translate");
    i0.ɵɵtemplate(95, NmswVesselVisitViewComponent_ng_template_2_ng_template_95_Template, 1, 1, "ng-template", 56);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(96, "kendo-tabstrip-tab", 55);
    i0.ɵɵpipe(97, "translate");
    i0.ɵɵtemplate(98, NmswVesselVisitViewComponent_ng_template_2_ng_template_98_Template, 1, 1, "ng-template", 56);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(99, "kendo-tabstrip-tab", 55);
    i0.ɵɵpipe(100, "translate");
    i0.ɵɵtemplate(101, NmswVesselVisitViewComponent_ng_template_2_ng_template_101_Template, 1, 1, "ng-template", 56);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(102, "kendo-tabstrip-tab", 55);
    i0.ɵɵpipe(103, "translate");
    i0.ɵɵtemplate(104, NmswVesselVisitViewComponent_ng_template_2_ng_template_104_Template, 1, 1, "ng-template", 56);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(105, "kendo-tabstrip-tab", 55);
    i0.ɵɵpipe(106, "translate");
    i0.ɵɵtemplate(107, NmswVesselVisitViewComponent_ng_template_2_ng_template_107_Template, 1, 1, "ng-template", 56);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(108, "kendo-tabstrip-tab", 55);
    i0.ɵɵpipe(109, "translate");
    i0.ɵɵtemplate(110, NmswVesselVisitViewComponent_ng_template_2_ng_template_110_Template, 1, 1, "ng-template", 56);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(111, "kendo-tabstrip-tab", 55);
    i0.ɵɵpipe(112, "translate");
    i0.ɵɵtemplate(113, NmswVesselVisitViewComponent_ng_template_2_ng_template_113_Template, 1, 1, "ng-template", 56);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(114, "kendo-tabstrip-tab", 55);
    i0.ɵɵpipe(115, "translate");
    i0.ɵɵtemplate(116, NmswVesselVisitViewComponent_ng_template_2_ng_template_116_Template, 1, 1, "ng-template", 56);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(117, "kendo-tabstrip-tab", 55);
    i0.ɵɵpipe(118, "translate");
    i0.ɵɵtemplate(119, NmswVesselVisitViewComponent_ng_template_2_ng_template_119_Template, 1, 1, "ng-template", 56);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const _r26 = i0.ɵɵreference(9);
    const _r29 = i0.ɵɵreference(13);
    const _r32 = i0.ɵɵreference(30);
    const _r37 = i0.ɵɵreference(44);
    const _r40 = i0.ɵɵreference(74);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("title", ctx_r1.title)("breadcrumb", ctx_r1.breadcrumb)("compacted", ctx_r1.cardView);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("entityId", ctx_r1.model.id)("color", ctx_r1.model.bookmarkColorId)("disabled", ctx_r1.cardView || ctx_r1.editMode);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.model.pendingVesselUpdate);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r1.model.vesselRevision)("ngIfElse", _r26);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r1.model.vesselRevision)("ngIfElse", _r29);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(16, 96, "Port Of Call"))("ngModel", ctx_r1.model.portId)("entity", ctx_r1.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(19, 98, "Berth/Area"))("ngModel", ctx_r1.model.berthId)("entity", ctx_r1.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(22, 100, "ATA"))("time", true)("ngModel", ctx_r1.model.ata)("entity", ctx_r1.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(25, 102, "ATD"))("time", true)("ngModel", ctx_r1.model.atd)("entity", ctx_r1.model);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r1.model.vesselRevision)("ngIfElse", _r32);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(33, 104, "Last Port Of Call"))("ngModel", ctx_r1.model.lastPortId)("entity", ctx_r1.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(36, 106, "Next Port Of Call"))("ngModel", ctx_r1.model.nextPortId)("entity", ctx_r1.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.model.vesselRevision);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.model.vesselRevision);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.model.vesselRevision)("ngIfElse", _r37);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(48, 108, "Primary Agent"))("ngModel", ctx_r1.model.agentId)("entity", ctx_r1.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(51, 110, "Additional Agents"))("multi", true)("ngModel", ctx_r1.model.additionalAgents)("entity", ctx_r1.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(54, 112, "Primary Purpose Of Call"))("ngModel", ctx_r1.model.vtsCallPurposeId)("entity", ctx_r1.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(57, 114, "Call Activity"))("ngModel", ctx_r1.model.callActivityId)("entity", ctx_r1.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(60, 116, "Additional Purposes Of Call"))("multi", true)("ngModel", ctx_r1.model.callPurposes)("entity", ctx_r1.model);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(64, 118, "MSW Visit Number"))("ngModel", ctx_r1.model.mswVisitNumber)("entity", ctx_r1.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(67, 120, "VTS Visit Number"))("ngModel", ctx_r1.model.visitNumber)("entity", ctx_r1.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(70, 122, "State"))("ngModel", ctx_r1.model.statusId)("entity", ctx_r1.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.model.vesselRevision)("ngIfElse", _r40);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(77, 124, "Arrival Remarks"))("ngModel", ctx_r1.model.arrivalCallPurposeRemarks)("entity", ctx_r1.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(80, 126, "Departure Remarks"))("ngModel", ctx_r1.model.departureRemarks)("entity", ctx_r1.model);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(84, 128, "Short Notification"))("ngModel", ctx_r1.model.isShort)("entity", ctx_r1.model);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(88, 130, "Vessel Events") + " (" + ctx_r1.countActive(ctx_r1.model.vtsEvents) + ")")("selected", ctx_r1.activeTab === 0);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(91, 132, "Cargo") + " (" + ctx_r1.countActive(ctx_r1.model.cargo) + ")")("selected", ctx_r1.activeTab === 1);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(94, 134, "Waste") + " (" + ctx_r1.countActive(ctx_r1.model.waste) + ")")("selected", ctx_r1.activeTab === 2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(97, 136, "Persons on Board") + " (" + ctx_r1.model.personsOnBoard + ")")("selected", ctx_r1.activeTab === 3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(100, 138, "Permits") + " (" + ctx_r1.countActive(ctx_r1.primaryVesselPermits) + ")")("selected", ctx_r1.activeTab === 4);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(103, 140, "Charge Candidates") + " (" + ctx_r1.countActive(ctx_r1.model.chargeCandidates) + ")")("selected", ctx_r1.activeTab === 5);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(106, 142, "Invoices") + " (" + ctx_r1.countActive(ctx_r1.model.invoices) + ")")("selected", ctx_r1.activeTab === 6);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(109, 144, "Energy Consumptions") + " (" + ctx_r1.countActive(ctx_r1.model.energyConsumptions) + ")")("selected", ctx_r1.activeTab === 7);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(112, 146, "Attachments") + " (" + ctx_r1.countActive(ctx_r1.model.attachments) + ")")("selected", ctx_r1.activeTab === 8);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(115, 148, "Remarks") + " (" + ctx_r1.countActive(ctx_r1.model.notes) + ")")("selected", ctx_r1.activeTab === 9);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(118, 150, "Vessel History") + " (" + ctx_r1.countActive(ctx_r1.model.vtsVesselVisitVesselRevisions) + ")")("selected", ctx_r1.activeTab === 10);
  }
}
function NmswVesselVisitViewComponent_ng_template_3_ng_template_5_span_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "codelist");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r119 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, i0.ɵɵpipeBind2(3, 3, row_r119.typeId, "EventType")), " ");
  }
}
function NmswVesselVisitViewComponent_ng_template_3_ng_template_5_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const row_r119 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵtextInterpolate1(" ", "Revised " + i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, row_r119.typeId, "EventType")), " ");
  }
}
function NmswVesselVisitViewComponent_ng_template_3_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NmswVesselVisitViewComponent_ng_template_3_ng_template_5_span_0_Template, 4, 6, "span", 82);
    i0.ɵɵtemplate(1, NmswVesselVisitViewComponent_ng_template_3_ng_template_5_ng_template_1_Template, 3, 6, "ng-template", null, 83, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    const row_r119 = ctx.$implicit;
    const _r121 = i0.ɵɵreference(2);
    i0.ɵɵproperty("ngIf", !row_r119.isRevised)("ngIfElse", _r121);
  }
}
function NmswVesselVisitViewComponent_ng_template_3_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-flag-icon", 84);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "codelist");
  }
  if (rf & 2) {
    const row_r125 = ctx.$implicit;
    i0.ɵɵproperty("code", row_r125.lastPortId)("floating", true);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, i0.ɵɵpipeBind2(3, 5, row_r125.lastPortId, "Port")), " ");
  }
}
function NmswVesselVisitViewComponent_ng_template_3_ng_template_13_span_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "codelist");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r126 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, i0.ɵɵpipeBind2(3, 3, row_r126.lastAreaId, "VtsArea")), " ");
  }
}
function NmswVesselVisitViewComponent_ng_template_3_ng_template_13_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const row_r126 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, row_r126.lastBerthId, "Berth")), " ");
  }
}
function NmswVesselVisitViewComponent_ng_template_3_ng_template_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NmswVesselVisitViewComponent_ng_template_3_ng_template_13_span_0_Template, 4, 6, "span", 82);
    i0.ɵɵtemplate(1, NmswVesselVisitViewComponent_ng_template_3_ng_template_13_ng_template_1_Template, 3, 6, "ng-template", null, 85, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    const row_r126 = ctx.$implicit;
    const _r128 = i0.ɵɵreference(2);
    i0.ɵɵproperty("ngIf", row_r126.lastAreaId)("ngIfElse", _r128);
  }
}
function NmswVesselVisitViewComponent_ng_template_3_ng_template_16_span_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "codelist");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r132 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, i0.ɵɵpipeBind2(3, 3, row_r132.nextAreaId, "VtsArea")), " ");
  }
}
function NmswVesselVisitViewComponent_ng_template_3_ng_template_16_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const row_r132 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, row_r132.nextBerthId, "Berth")), " ");
  }
}
function NmswVesselVisitViewComponent_ng_template_3_ng_template_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NmswVesselVisitViewComponent_ng_template_3_ng_template_16_span_0_Template, 4, 6, "span", 82);
    i0.ɵɵtemplate(1, NmswVesselVisitViewComponent_ng_template_3_ng_template_16_ng_template_1_Template, 3, 6, "ng-template", null, 86, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    const row_r132 = ctx.$implicit;
    const _r134 = i0.ɵɵreference(2);
    i0.ɵɵproperty("ngIf", row_r132.nextAreaId)("ngIfElse", _r134);
  }
}
function NmswVesselVisitViewComponent_ng_template_3_ng_template_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-flag-icon", 84);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "codelist");
  }
  if (rf & 2) {
    const row_r138 = ctx.$implicit;
    i0.ɵɵproperty("code", row_r138.nextPortId)("floating", true);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, i0.ɵɵpipeBind2(3, 5, row_r138.nextPortId, "Port")), " ");
  }
}
function NmswVesselVisitViewComponent_ng_template_3_ng_template_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const row_r139 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, row_r139.shiftCallPurposeId, "ShiftCallPurpose")), " ");
  }
}
function NmswVesselVisitViewComponent_ng_template_3_ng_template_25_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const row_r140 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", (row_r140.serviceVessel == null ? null : row_r140.serviceVessel.name) || "-", " ");
  }
}
function NmswVesselVisitViewComponent_ng_template_3_ng_template_28_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-check-icon", 87);
  }
  if (rf & 2) {
    const row_r142 = ctx.$implicit;
    const ctx_r118 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("check", ctx_r118.eventHasAnyChargeCandidates(row_r142.id));
  }
}
function NmswVesselVisitViewComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "app-grid", 67);
    i0.ɵɵelement(1, "kendo-grid-column", 68);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "kendo-grid-column", 69);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵtemplate(5, NmswVesselVisitViewComponent_ng_template_3_ng_template_5_Template, 3, 2, "ng-template", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "kendo-grid-column", 71);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementStart(8, "kendo-grid-column", 72);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵtemplate(10, NmswVesselVisitViewComponent_ng_template_3_ng_template_10_Template, 4, 8, "ng-template", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "kendo-grid-column", 73);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵtemplate(13, NmswVesselVisitViewComponent_ng_template_3_ng_template_13_Template, 3, 2, "ng-template", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "kendo-grid-column", 74);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵtemplate(16, NmswVesselVisitViewComponent_ng_template_3_ng_template_16_Template, 3, 2, "ng-template", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "kendo-grid-column", 75);
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵtemplate(19, NmswVesselVisitViewComponent_ng_template_3_ng_template_19_Template, 4, 8, "ng-template", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "kendo-grid-column", 76);
    i0.ɵɵpipe(21, "translate");
    i0.ɵɵtemplate(22, NmswVesselVisitViewComponent_ng_template_3_ng_template_22_Template, 3, 6, "ng-template", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "kendo-grid-column", 77);
    i0.ɵɵpipe(24, "translate");
    i0.ɵɵtemplate(25, NmswVesselVisitViewComponent_ng_template_3_ng_template_25_Template, 1, 1, "ng-template", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "kendo-grid-column", 78);
    i0.ɵɵpipe(27, "translate");
    i0.ɵɵtemplate(28, NmswVesselVisitViewComponent_ng_template_3_ng_template_28_Template, 1, 1, "ng-template", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(29, "kendo-grid-column", 79);
    i0.ɵɵpipe(30, "translate");
    i0.ɵɵelement(31, "kendo-grid-column", 80);
    i0.ɵɵpipe(32, "translate");
    i0.ɵɵelement(33, "kendo-grid-column", 81);
    i0.ɵɵpipe(34, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("data", ctx_r3.events)("sort", ctx_r3.eventsSort)("sortable", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(2, 19, "ID"))("hidden", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(4, 21, "Event Type"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(7, 23, "Event Date"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(9, 25, "Last Port Of Call"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(12, 27, "From Berth/Area"))("sortable", false);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(15, 29, "To Berth/Area"))("sortable", false);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(18, 31, "Next Port Of Call"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(21, 33, "Purpose Of Shifting"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(24, 35, "Service Vessel"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(27, 37, "Charge Candidates"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(30, 39, "Reason for Cancelled Operations"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(32, 41, "VTS Remarks"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(34, 43, "tmSW Remarks"));
  }
}
function NmswVesselVisitViewComponent_ng_template_5_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-flag-icon", 84);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "codelist");
  }
  if (rf & 2) {
    const row_r154 = ctx.$implicit;
    i0.ɵɵproperty("code", row_r154.portOfLoadingId)("floating", true);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, i0.ɵɵpipeBind2(3, 5, row_r154.portOfLoadingId, "Port")), " ");
  }
}
function NmswVesselVisitViewComponent_ng_template_5_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-flag-icon", 84);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "codelist");
  }
  if (rf & 2) {
    const row_r155 = ctx.$implicit;
    i0.ɵɵproperty("code", row_r155.portOfDischargeId)("floating", true);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, i0.ɵɵpipeBind2(3, 5, row_r155.portOfDischargeId, "Port")), " ");
  }
}
function NmswVesselVisitViewComponent_ng_template_5_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const row_r156 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, row_r156.manifestCargoTypeId, "ManifestCargoType")), " ");
  }
}
function NmswVesselVisitViewComponent_ng_template_5_ng_template_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const row_r157 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, row_r157.commodityId, "Commodity")), " ");
  }
}
function NmswVesselVisitViewComponent_ng_template_5_ng_template_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "number");
  }
  if (rf & 2) {
    const row_r158 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(1, 1, row_r158.netWeight, "1.3", "en"), " ");
  }
}
function NmswVesselVisitViewComponent_ng_template_5_ng_template_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "number");
  }
  if (rf & 2) {
    const row_r159 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind3(1, 1, row_r159.grossWeight, "1.3", "en"), " ");
  }
}
function NmswVesselVisitViewComponent_ng_template_5_ng_template_25_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const row_r160 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, row_r160.unitOfMeasurementId, "UnitOfMeasurement")), " ");
  }
}
function NmswVesselVisitViewComponent_ng_template_5_ng_template_28_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const row_r161 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, row_r161.packagingTypeId, "PackagingType")), " ");
  }
}
function NmswVesselVisitViewComponent_ng_template_5_ng_template_31_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const row_r162 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, row_r162.imdgClassId, "Imdg")), " ");
  }
}
function NmswVesselVisitViewComponent_ng_template_5_ng_template_34_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-check-icon", 87);
  }
  if (rf & 2) {
    const row_r164 = ctx.$implicit;
    i0.ɵɵproperty("check", row_r164.notificationTypeCode === "A");
  }
}
function NmswVesselVisitViewComponent_ng_template_5_ng_template_37_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-check-icon", 87);
  }
  if (rf & 2) {
    const row_r166 = ctx.$implicit;
    i0.ɵɵproperty("check", !!row_r166.imdgClassId);
  }
}
function NmswVesselVisitViewComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "app-grid", 88);
    i0.ɵɵelement(1, "kendo-grid-column", 68);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "kendo-grid-column", 89);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵtemplate(5, NmswVesselVisitViewComponent_ng_template_5_ng_template_5_Template, 4, 8, "ng-template", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "kendo-grid-column", 90);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵtemplate(8, NmswVesselVisitViewComponent_ng_template_5_ng_template_8_Template, 4, 8, "ng-template", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "kendo-grid-column", 91);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵtemplate(11, NmswVesselVisitViewComponent_ng_template_5_ng_template_11_Template, 3, 6, "ng-template", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "kendo-grid-column", 92);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵtemplate(14, NmswVesselVisitViewComponent_ng_template_5_ng_template_14_Template, 3, 6, "ng-template", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "kendo-grid-column", 93);
    i0.ɵɵpipe(16, "translate");
    i0.ɵɵtemplate(17, NmswVesselVisitViewComponent_ng_template_5_ng_template_17_Template, 2, 5, "ng-template", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "kendo-grid-column", 94);
    i0.ɵɵpipe(19, "translate");
    i0.ɵɵtemplate(20, NmswVesselVisitViewComponent_ng_template_5_ng_template_20_Template, 2, 5, "ng-template", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(21, "kendo-grid-column", 95);
    i0.ɵɵpipe(22, "translate");
    i0.ɵɵelementStart(23, "kendo-grid-column", 96);
    i0.ɵɵpipe(24, "translate");
    i0.ɵɵtemplate(25, NmswVesselVisitViewComponent_ng_template_5_ng_template_25_Template, 3, 6, "ng-template", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "kendo-grid-column", 97);
    i0.ɵɵpipe(27, "translate");
    i0.ɵɵtemplate(28, NmswVesselVisitViewComponent_ng_template_5_ng_template_28_Template, 3, 6, "ng-template", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "kendo-grid-column", 98);
    i0.ɵɵpipe(30, "translate");
    i0.ɵɵtemplate(31, NmswVesselVisitViewComponent_ng_template_5_ng_template_31_Template, 3, 6, "ng-template", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(32, "kendo-grid-column", 99);
    i0.ɵɵpipe(33, "translate");
    i0.ɵɵtemplate(34, NmswVesselVisitViewComponent_ng_template_5_ng_template_34_Template, 1, 1, "ng-template", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(35, "kendo-grid-column", 98);
    i0.ɵɵpipe(36, "translate");
    i0.ɵɵtemplate(37, NmswVesselVisitViewComponent_ng_template_5_ng_template_37_Template, 1, 1, "ng-template", 70);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("data", ctx_r5.model.cargo);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(2, 15, "ID"))("hidden", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(4, 17, "Port Of Loading"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(7, 19, "Port Of Discharge"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(10, 21, "Cargo Type"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(13, 23, "Commodity"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(16, 25, "Net Weight"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(19, 27, "Gross Weight"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(22, 29, "Quantity"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(24, 31, "Unit Of Measurement"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(27, 33, "Packaging Type"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(30, 35, "IMDG Class"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(33, 37, "Is Arrival"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(36, 39, "Has DPG"));
  }
}
function NmswVesselVisitViewComponent_ng_template_7_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const row_r168 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, row_r168.wasteTypeId, "WasteType")), " ");
  }
}
function NmswVesselVisitViewComponent_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "app-grid", 88);
    i0.ɵɵelement(1, "kendo-grid-column", 68);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "kendo-grid-column", 100);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵtemplate(5, NmswVesselVisitViewComponent_ng_template_7_ng_template_5_Template, 3, 6, "ng-template", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "kendo-grid-column", 95);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵproperty("data", ctx_r7.model.waste);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(2, 5, "ID"))("hidden", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(4, 7, "Waste Type"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(7, 9, "Quantity"));
  }
}
function NmswVesselVisitViewComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "app-grid", 88);
    i0.ɵɵelement(1, "kendo-grid-column", 101);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelement(3, "kendo-grid-column", 102);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelement(5, "kendo-grid-column", 103);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelement(7, "kendo-grid-column", 104);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵproperty("data", ctx_r9.personsOnBoard);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(2, 5, "Disembarking Passengers"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(4, 7, "Embarking Passengers"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(6, 9, "Transiting Passengers"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(8, 11, "Crew"));
  }
}
const _c1 = function (a1) {
  return ["/vessel-permit/view/", a1];
};
function NmswVesselVisitViewComponent_ng_template_11_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 116);
    i0.ɵɵelement(1, "fa-icon", 117);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "a", 118);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r177 = ctx.$implicit;
    const ctx_r169 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("href", ctx_r169.nmswPermitViewUrl + row_r177.id, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(3, _c1, row_r177.id));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", row_r177.referenceNumber, " ");
  }
}
function NmswVesselVisitViewComponent_ng_template_11_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const row_r178 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, row_r178.permitTypeId, "PermitType")), " ");
  }
}
function NmswVesselVisitViewComponent_ng_template_11_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const row_r179 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, row_r179.permitStatusId, "PermitStatus")), " ");
  }
}
function NmswVesselVisitViewComponent_ng_template_11_ng_template_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const row_r180 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, row_r180.requestingOrganizationId, "Organization")), " ");
  }
}
function NmswVesselVisitViewComponent_ng_template_11_ng_template_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const row_r181 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, row_r181.berthId, "Berth")), " ");
  }
}
function NmswVesselVisitViewComponent_ng_template_11_ng_template_26_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-check-icon", 87);
  }
  if (rf & 2) {
    const row_r183 = ctx.$implicit;
    const ctx_r174 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("check", ctx_r174.permitHasAnyChargeCandidates(row_r183.id));
  }
}
function NmswVesselVisitViewComponent_ng_template_11_ng_template_29_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-check-icon", 87);
  }
  if (rf & 2) {
    const row_r185 = ctx.$implicit;
    i0.ɵɵproperty("check", row_r185.notificationTypeCode === "A");
  }
}
function NmswVesselVisitViewComponent_ng_template_11_ng_template_30_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-vessel-permit-detail", 119);
  }
  if (rf & 2) {
    const dataItem_r186 = ctx.$implicit;
    i0.ɵɵproperty("primaryPermitId", dataItem_r186.id);
  }
}
function NmswVesselVisitViewComponent_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "app-grid", 105);
    i0.ɵɵelement(1, "kendo-grid-column", 68);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "kendo-grid-column", 106);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵtemplate(5, NmswVesselVisitViewComponent_ng_template_11_ng_template_5_Template, 4, 5, "ng-template", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "kendo-grid-column", 107);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵtemplate(8, NmswVesselVisitViewComponent_ng_template_11_ng_template_8_Template, 3, 6, "ng-template", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "kendo-grid-column", 108);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵtemplate(11, NmswVesselVisitViewComponent_ng_template_11_ng_template_11_Template, 3, 6, "ng-template", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "kendo-grid-column", 109);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵtemplate(14, NmswVesselVisitViewComponent_ng_template_11_ng_template_14_Template, 3, 6, "ng-template", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "kendo-grid-column", 110);
    i0.ɵɵpipe(16, "translate");
    i0.ɵɵtemplate(17, NmswVesselVisitViewComponent_ng_template_11_ng_template_17_Template, 3, 6, "ng-template", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(18, "kendo-grid-column", 111);
    i0.ɵɵpipe(19, "translate");
    i0.ɵɵelement(20, "kendo-grid-column", 112);
    i0.ɵɵpipe(21, "translate");
    i0.ɵɵelement(22, "kendo-grid-column", 113);
    i0.ɵɵpipe(23, "translate");
    i0.ɵɵelementStart(24, "kendo-grid-column", 114);
    i0.ɵɵpipe(25, "translate");
    i0.ɵɵtemplate(26, NmswVesselVisitViewComponent_ng_template_11_ng_template_26_Template, 1, 1, "ng-template", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "kendo-grid-column", 99);
    i0.ɵɵpipe(28, "translate");
    i0.ɵɵtemplate(29, NmswVesselVisitViewComponent_ng_template_11_ng_template_29_Template, 1, 1, "ng-template", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(30, NmswVesselVisitViewComponent_ng_template_11_ng_template_30_Template, 1, 1, "ng-template", 115);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵproperty("data", ctx_r11.primaryVesselPermits)("sortable", true)("sort", ctx_r11.permitsSort);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(2, 15, "ID"))("hidden", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(4, 17, "Permit Number"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(7, 19, "Permit Type"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(10, 21, "Permit Status"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(13, 23, "Requesting Organization"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(16, 25, "Area"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(19, 27, "MSW Approval Date"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(21, 29, "Valid From"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(23, 31, "Valid To"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(25, 33, "Charge Candidates"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(28, 35, "Is Arrival"));
  }
}
function NmswVesselVisitViewComponent_ng_template_13_kendo_grid_checkbox_column_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "kendo-grid-checkbox-column", 136);
  }
}
function NmswVesselVisitViewComponent_ng_template_13_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const dataItem_r201 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, dataItem_r201.serviceId, "Service")), " ");
  }
}
const _c2 = function (a0) {
  return {
    text: a0,
    separator: ";",
    width: "250px"
  };
};
function NmswVesselVisitViewComponent_ng_template_13_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-popover-list", 88);
  }
  if (rf & 2) {
    const dataItem_r202 = ctx.$implicit;
    i0.ɵɵproperty("data", i0.ɵɵpureFunction1(1, _c2, dataItem_r202.description));
  }
}
function NmswVesselVisitViewComponent_ng_template_13_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-check-icon", 137);
  }
  if (rf & 2) {
    const dataItem_r203 = ctx.$implicit;
    i0.ɵɵproperty("check", !!dataItem_r203.invoiceItemId)("neutral", !dataItem_r203.active);
  }
}
function NmswVesselVisitViewComponent_ng_template_13_ng_template_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r206 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 138);
    i0.ɵɵlistener("ngModelChange", function NmswVesselVisitViewComponent_ng_template_13_ng_template_14_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r206);
      const dataItem_r204 = restoredCtx.dataItem;
      return i0.ɵɵresetView(dataItem_r204.from = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r204 = ctx.dataItem;
    i0.ɵɵproperty("time", true)("isDisabled", !!dataItem_r204.invoiceItemId)("ngModel", dataItem_r204.from)("entity", dataItem_r204);
  }
}
function NmswVesselVisitViewComponent_ng_template_13_ng_template_17_Template(rf, ctx) {
  if (rf & 1) {
    const _r209 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 139);
    i0.ɵɵlistener("ngModelChange", function NmswVesselVisitViewComponent_ng_template_13_ng_template_17_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r209);
      const dataItem_r207 = restoredCtx.dataItem;
      return i0.ɵɵresetView(dataItem_r207.to = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r207 = ctx.dataItem;
    i0.ɵɵproperty("time", true)("isDisabled", !!dataItem_r207.invoiceItemId)("ngModel", dataItem_r207.to)("entity", dataItem_r207);
  }
}
function NmswVesselVisitViewComponent_ng_template_13_ng_template_20_Template(rf, ctx) {
  if (rf & 1) {
    const _r212 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 140);
    i0.ɵɵlistener("ngModelChange", function NmswVesselVisitViewComponent_ng_template_13_ng_template_20_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r212);
      const dataItem_r210 = restoredCtx.dataItem;
      return i0.ɵɵresetView(dataItem_r210.total = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r210 = ctx.dataItem;
    i0.ɵɵproperty("isDisabled", !!dataItem_r210.invoiceItemId)("ngModel", dataItem_r210.total)("entity", dataItem_r210);
  }
}
function NmswVesselVisitViewComponent_ng_template_13_ng_template_21_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "number");
  }
  if (rf & 2) {
    const dataItem_r213 = ctx.$implicit;
    const ctx_r194 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind2(1, 2, dataItem_r213.total, "1.2-2"), " ", ctx_r194.currency, " ");
  }
}
function NmswVesselVisitViewComponent_ng_template_13_ng_template_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const dataItem_r214 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, dataItem_r214.createdById, "User")), " ");
  }
}
function NmswVesselVisitViewComponent_ng_template_13_ng_template_29_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const dataItem_r215 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, dataItem_r215 == null ? null : dataItem_r215.lastModifiedById, "User")), " ");
  }
}
function NmswVesselVisitViewComponent_ng_template_13_ng_template_34_Template(rf, ctx) {
  if (rf & 1) {
    const _r218 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 141);
    i0.ɵɵlistener("ngModelChange", function NmswVesselVisitViewComponent_ng_template_13_ng_template_34_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r218);
      const dataItem_r216 = restoredCtx.$implicit;
      return i0.ɵɵresetView(dataItem_r216.doubleRate = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r216 = ctx.$implicit;
    i0.ɵɵproperty("isDisabled", true)("ngModel", dataItem_r216.doubleRate)("entity", dataItem_r216);
  }
}
function NmswVesselVisitViewComponent_ng_template_13_ng_template_35_Template(rf, ctx) {
  if (rf & 1) {
    const _r221 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 141);
    i0.ɵɵlistener("ngModelChange", function NmswVesselVisitViewComponent_ng_template_13_ng_template_35_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r221);
      const dataItem_r219 = restoredCtx.dataItem;
      return i0.ɵɵresetView(dataItem_r219.doubleRate = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r219 = ctx.dataItem;
    i0.ɵɵproperty("isDisabled", !!dataItem_r219.invoiceItemId)("ngModel", dataItem_r219.doubleRate)("entity", dataItem_r219);
  }
}
function NmswVesselVisitViewComponent_ng_template_13_ng_template_38_Template(rf, ctx) {
  if (rf & 1) {
    const _r224 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 142);
    i0.ɵɵlistener("ngModelChange", function NmswVesselVisitViewComponent_ng_template_13_ng_template_38_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r224);
      const dataItem_r222 = restoredCtx.$implicit;
      return i0.ɵɵresetView(dataItem_r222.active = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r222 = ctx.$implicit;
    i0.ɵɵproperty("isDisabled", true)("ngModel", dataItem_r222.active)("entity", dataItem_r222);
  }
}
function NmswVesselVisitViewComponent_ng_template_13_ng_template_39_Template(rf, ctx) {
  if (rf & 1) {
    const _r227 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 142);
    i0.ɵɵlistener("ngModelChange", function NmswVesselVisitViewComponent_ng_template_13_ng_template_39_Template_app_control_ngModelChange_0_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r227);
      const dataItem_r225 = restoredCtx.dataItem;
      return i0.ɵɵresetView(dataItem_r225.active = $event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r225 = ctx.dataItem;
    i0.ɵɵproperty("isDisabled", !!dataItem_r225.invoiceItemId)("ngModel", dataItem_r225.active)("entity", dataItem_r225);
  }
}
const _c3 = function () {
  return {
    enabled: true,
    checkboxOnly: true
  };
};
function NmswVesselVisitViewComponent_ng_template_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r229 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-toggleable-filter", 120);
    i0.ɵɵlistener("filterToggled", function NmswVesselVisitViewComponent_ng_template_13_Template_app_toggleable_filter_filterToggled_0_listener($event) {
      i0.ɵɵrestoreView(_r229);
      const ctx_r228 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r228.filterChargeCandidates($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(1, "app-editable-grid", 121);
    i0.ɵɵlistener("selectionChange", function NmswVesselVisitViewComponent_ng_template_13_Template_app_editable_grid_selectionChange_1_listener($event) {
      i0.ɵɵrestoreView(_r229);
      const ctx_r230 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r230.selectedChargeCandidates = $event);
    });
    i0.ɵɵtemplate(2, NmswVesselVisitViewComponent_ng_template_13_kendo_grid_checkbox_column_2_Template, 1, 0, "kendo-grid-checkbox-column", 122);
    i0.ɵɵelementStart(3, "kendo-grid-column", 123);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵtemplate(5, NmswVesselVisitViewComponent_ng_template_13_ng_template_5_Template, 3, 6, "ng-template", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "kendo-grid-column", 124);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵtemplate(8, NmswVesselVisitViewComponent_ng_template_13_ng_template_8_Template, 1, 3, "ng-template", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "kendo-grid-column", 125);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵtemplate(11, NmswVesselVisitViewComponent_ng_template_13_ng_template_11_Template, 1, 2, "ng-template", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "kendo-grid-column", 126);
    i0.ɵɵpipe(13, "translate");
    i0.ɵɵtemplate(14, NmswVesselVisitViewComponent_ng_template_13_ng_template_14_Template, 1, 4, "ng-template", 127);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "kendo-grid-column", 128);
    i0.ɵɵpipe(16, "translate");
    i0.ɵɵtemplate(17, NmswVesselVisitViewComponent_ng_template_13_ng_template_17_Template, 1, 4, "ng-template", 127);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "kendo-grid-column", 129);
    i0.ɵɵpipe(19, "translate");
    i0.ɵɵtemplate(20, NmswVesselVisitViewComponent_ng_template_13_ng_template_20_Template, 1, 3, "ng-template", 127);
    i0.ɵɵtemplate(21, NmswVesselVisitViewComponent_ng_template_13_ng_template_21_Template, 2, 5, "ng-template", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "kendo-grid-column", 130);
    i0.ɵɵpipe(23, "translate");
    i0.ɵɵtemplate(24, NmswVesselVisitViewComponent_ng_template_13_ng_template_24_Template, 3, 6, "ng-template", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(25, "kendo-grid-column", 131);
    i0.ɵɵpipe(26, "translate");
    i0.ɵɵelementStart(27, "kendo-grid-column", 132);
    i0.ɵɵpipe(28, "translate");
    i0.ɵɵtemplate(29, NmswVesselVisitViewComponent_ng_template_13_ng_template_29_Template, 3, 6, "ng-template", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(30, "kendo-grid-column", 133);
    i0.ɵɵpipe(31, "translate");
    i0.ɵɵelementStart(32, "kendo-grid-column", 134);
    i0.ɵɵpipe(33, "translate");
    i0.ɵɵtemplate(34, NmswVesselVisitViewComponent_ng_template_13_ng_template_34_Template, 1, 3, "ng-template", 70);
    i0.ɵɵtemplate(35, NmswVesselVisitViewComponent_ng_template_13_ng_template_35_Template, 1, 3, "ng-template", 127);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(36, "kendo-grid-column", 135);
    i0.ɵɵpipe(37, "translate");
    i0.ɵɵtemplate(38, NmswVesselVisitViewComponent_ng_template_13_ng_template_38_Template, 1, 3, "ng-template", 70);
    i0.ɵɵtemplate(39, NmswVesselVisitViewComponent_ng_template_13_ng_template_39_Template, 1, 3, "ng-template", 127);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext();
    i0.ɵɵproperty("filters", ctx_r13.chargeCandidateFilters);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("data", ctx_r13.displayedChargeCandidates)("selectable", i0.ɵɵpureFunction0(46, _c3))("selectBy", "id")("sort", ctx_r13.chargeCandidatesSort)("editMode", ctx_r13.editMode && !ctx_r13.cardView && !ctx_r13.vesselVisitCompleted())("canAddNew", false)("canDelete", false)("selection", ctx_r13.selectedChargeCandidates);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r13.editMode);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(4, 22, "Service"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(7, 24, "Description"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(10, 26, "Invoiced"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(13, 28, "Charge From"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(16, 30, "Charge To"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(19, 32, "Total"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(23, 34, "Created By"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(26, 36, "Created Date"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(28, 38, "Last Modified By"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(31, 40, "Last Modified Date"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(33, 42, "Double Rate"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(37, 44, "Active"));
  }
}
function NmswVesselVisitViewComponent_ng_template_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-invoice-list", 143);
  }
  if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext();
    i0.ɵɵproperty("editMode", ctx_r15.editMode && !ctx_r15.cardView)("items", ctx_r15.model.invoices);
  }
}
function NmswVesselVisitViewComponent_ng_template_17_ng_template_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "app-grid", 88);
    i0.ɵɵelement(1, "kendo-grid-column", 153);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelement(3, "kendo-grid-column", 154);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelement(5, "kendo-grid-column", 149);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dataItem_r232 = ctx.$implicit;
    i0.ɵɵproperty("data", dataItem_r232.deltas);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(2, 4, "TimeStamp"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(4, 6, "DeltaEnergy (kWh)"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(6, 8, "Terminal"));
  }
}
function NmswVesselVisitViewComponent_ng_template_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 144)(1, "div", 20)(2, "h5", 145);
    i0.ɵɵtext(3, "Energy Consumptions");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "app-grid", 88);
    i0.ɵɵelement(5, "kendo-grid-column", 146);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelement(7, "kendo-grid-column", 147);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelement(9, "kendo-grid-column", 148);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelement(11, "kendo-grid-column", 149);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelement(13, "kendo-grid-column", 150);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelement(15, "kendo-grid-column", 151);
    i0.ɵɵpipe(16, "translate");
    i0.ɵɵelement(17, "kendo-grid-column", 152);
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵtemplate(19, NmswVesselVisitViewComponent_ng_template_17_ng_template_19_Template, 7, 10, "ng-template", 115);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("data", ctx_r17.model.energyConsumptions);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(6, 8, "Voltage (V (11000/6600))"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(8, 10, "Frequency (Hz (50/60))"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(10, 12, "Shore Identification"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(12, 14, "Terminal"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(14, 16, "Total Energy (kWh)"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(16, 18, "Connection TimeStamp"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(18, 20, "Disconnection TimeStamp"));
  }
}
function NmswVesselVisitViewComponent_ng_template_19_Template(rf, ctx) {
  if (rf & 1) {
    const _r235 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 155, 156);
    i0.ɵɵlistener("ngModelChange", function NmswVesselVisitViewComponent_ng_template_19_Template_app_control_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r235);
      const ctx_r234 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r234.model.attachments = $event);
    })("addFile", function NmswVesselVisitViewComponent_ng_template_19_Template_app_control_addFile_0_listener($event) {
      i0.ɵɵrestoreView(_r235);
      const ctx_r236 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r236.onAddFile($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext();
    i0.ɵɵproperty("multiple", true)("editMode", ctx_r19.editMode && !ctx_r19.cardView)("ngModel", ctx_r19.model.attachments)("entity", ctx_r19.model);
  }
}
function NmswVesselVisitViewComponent_ng_template_21_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-note-list", 157);
  }
  if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext();
    i0.ɵɵproperty("items", ctx_r21.model.notes)("editMode", ctx_r21.editMode && !ctx_r21.cardView);
  }
}
const _c4 = function (a2) {
  return ["/vessel-revision", "view", a2];
};
function NmswVesselVisitViewComponent_ng_template_23_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 118);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r240 = ctx.$implicit;
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(2, _c4, row_r240.id));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", row_r240.id, " ");
  }
}
function NmswVesselVisitViewComponent_ng_template_23_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-flag-icon", 167);
  }
  if (rf & 2) {
    const row_r241 = ctx.$implicit;
    i0.ɵɵproperty("code", row_r241.countryId)("floating", true);
  }
}
function NmswVesselVisitViewComponent_ng_template_23_ng_template_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const row_r242 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, row_r242.typeId, "VesselType")), " ");
  }
}
function NmswVesselVisitViewComponent_ng_template_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "app-grid", 105)(1, "kendo-grid-column", 158);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtemplate(3, NmswVesselVisitViewComponent_ng_template_23_ng_template_3_Template, 2, 4, "ng-template", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "kendo-grid-column", 159);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelement(6, "kendo-grid-column", 160);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelement(8, "kendo-grid-column", 161);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementStart(10, "kendo-grid-column", 162);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵtemplate(12, NmswVesselVisitViewComponent_ng_template_23_ng_template_12_Template, 1, 2, "ng-template", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "kendo-grid-column", 163);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵtemplate(15, NmswVesselVisitViewComponent_ng_template_23_ng_template_15_Template, 3, 6, "ng-template", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(16, "kendo-grid-column", 164);
    i0.ɵɵpipe(17, "translate");
    i0.ɵɵelement(18, "kendo-grid-column", 165);
    i0.ɵɵpipe(19, "translate");
    i0.ɵɵelement(20, "kendo-grid-column", 166);
    i0.ɵɵpipe(21, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext();
    i0.ɵɵproperty("data", ctx_r23.activeRevisions)("sortable", false)("sort", ctx_r23.vesselRevisionSort);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("width", 100)("title", i0.ɵɵpipeBind1(2, 21, "Revision Id"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("width", 150)("title", i0.ɵɵpipeBind1(5, 23, "Created Date"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("width", 150)("title", i0.ɵɵpipeBind1(7, 25, "Date Applied to Visit"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("width", 175)("title", i0.ɵɵpipeBind1(9, 27, "Vessel Name"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("width", 200)("title", i0.ɵɵpipeBind1(11, 29, "Flag"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("width", 200)("title", i0.ɵɵpipeBind1(14, 31, "Vessel Type"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("width", 100)("title", i0.ɵɵpipeBind1(17, 33, "NRT"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("width", 100)("title", i0.ɵɵpipeBind1(19, 35, "GRT"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("width", 100)("title", i0.ɵɵpipeBind1(21, 37, "LOA"));
  }
}
export class NmswVesselVisitViewComponent extends AbstractBreezeViewComponent {
  get title() {
    const vesselVisit = this.translateService.instant(`${this.visitSource.uppercase} Vessel Visit`);
    const vessel = ` | ${this.model.vesselRevision?.name || this.model.vtsVessel?.name}`;
    const visitNumber = ` | ${this.visitSource.lowercase === 'vts' ? this.model.visitNumber : this.model.mswVisitNumber}`;
    const status = ` | ${this.model.statusId}`;
    return `${vesselVisit}${vessel}${visitNumber}${status}`;
  }
  get isBillable() {
    return ![VesselVisitStatusCodes.Closed, VesselVisitStatusCodes.NonBillable].includes(this.model?.statusId);
  }
  get isCompleted() {
    return [VesselVisitStatusCodes.Completed, VesselVisitStatusCodes.NonBillable].includes(this.model?.statusId);
  }
  get laidUpBegan() {
    return this.model.vtsEvents.map(ev => ev.typeId).includes(EventTypeCodes.LaidUpFrom);
  }
  get laidUpCompleted() {
    return this.model.vtsEvents.map(ev => ev.typeId).includes(EventTypeCodes.LaidUpTo);
  }
  get revisions() {
    return this.model.vtsVesselVisitVesselRevisions.map(revision => revision.vesselRevision);
  }
  get activeRevisions() {
    return this.model.vtsVesselVisitVesselRevisions.filter(revision => revision.active).map(revision => revision.vesselRevision);
  }
  constructor(breezeViewService, dialogService) {
    super(breezeViewService);
    this.breezeViewService = breezeViewService;
    this.dialogService = dialogService;
    this.cardView = false;
    this.entityName = 'VtsVesselVisit';
    this.editPermission = VTSPermissions.Action.edit;
    this.chargeCandidateFilters = chargeCandidateFilters;
    this.primaryVesselPermits = [];
    this.displayedChargeCandidates = [];
    this.selectedChargeCandidates = [];
    this.personsOnBoard = [];
    this.parentRoute = '';
    this.breadcrumb = [];
    this.visitSource = {
      lowercase: '',
      uppercase: ''
    };
    this.eventsSort = [{
      field: 'eventTime',
      dir: 'desc'
    }];
    this.chargeCandidatesSort = [{
      field: 'active',
      dir: 'desc'
    }, {
      field: 'from',
      dir: 'desc'
    }, {
      field: 'to',
      dir: 'desc'
    }];
    this.permitsSort = [{
      field: 'approvalDate',
      dir: 'asc'
    }];
    this.vesselRevisionSort = [{
      field: 'createdDate',
      dir: 'desc'
    }];
    this.isDevelopEnvironment = ['local', 'development', 'staging'].includes(environment.environment);
    this.nmswPermitViewUrl = environment.settings.nmswPermitViewUrl;
  }
  ngOnInit() {
    if (this.vtsVesselVisit != null) {
      this.model = this.vtsVesselVisit;
      this.breadcrumb = [];
      this.cardView = true;
      this.rememberTabs = false;
      this.modelLoaded();
    } else {
      super.ngOnInit();
    }
  }
  modelLoaded() {
    super.modelLoaded();
    this.actionBar.push({
      label: this.translateService.instant('Invoice'),
      items: [{
        label: () => this.translateService.instant('Create Invoice'),
        icon: 'plus',
        isVisible: () => !this.createMode,
        isDisabled: () => !this.isBillable || this.editMode,
        onClick: () => this.createInvoice()
      }, {
        label: () => this.translateService.instant('Add Existing Invoice'),
        icon: 'plus',
        isVisible: () => !this.createMode,
        isDisabled: () => !this.isBillable || this.editMode,
        onClick: () => this.addExistingInvoice()
      }]
    });
    this.actionBar.push({
      label: this.translateService.instant('Workflow'),
      items: [{
        label: () => this.translateService.instant('Non-Billable'),
        icon: 'handshake',
        isDisabled: () => this.model?.statusId !== VesselVisitStatusCodes.Active || this.editMode,
        onClick: () => this.noBill()
      }, {
        label: () => this.translateService.instant('Charge'),
        icon: 'cash-register',
        isDisabled: () => this.vesselVisitCompleted() || this.editMode,
        onClick: () => this.charge()
      }, {
        label: () => this.translateService.instant('Complete'),
        icon: 'clipboard-check',
        isVisible: () => !this.createMode,
        isDisabled: () => this.model?.statusId !== VesselVisitStatusCodes.Billed || this.editMode,
        onClick: () => this.complete()
      }, {
        label: this.translateService.instant('Send To Archive'),
        icon: 'archive',
        isVisible: () => !this.createMode,
        isDisabled: () => this.model.archived || !this.isCompleted || this.editMode,
        onClick: () => this.archive()
      }]
    });
    this.actionBar.push({
      label: this.translateService.instant('Charge candidates'),
      items: [{
        label: () => this.translateService.instant('Generate Candidates (debug)'),
        icon: 'cog',
        isVisible: this.isDevelopEnvironment,
        isDisabled: () => this.vesselVisitCompleted() || this.editMode,
        onClick: () => this.generateCandidates()
      }, {
        label: () => this.translateService.instant('Toggle double rate'),
        icon: 'sliders',
        isVisible: () => !this.createMode,
        isDisabled: () => this.selectedChargeCandidates.length === 0 || this.editMode,
        onClick: () => this.toggle('ToggleDoubleRateChargeCandidates', 'Toggle double rate on Charge candidates', 'You are about to toggle double rates on selected')
      }, {
        label: () => this.translateService.instant('Toggle active'),
        icon: 'sliders',
        isVisible: () => !this.createMode,
        isDisabled: () => this.selectedChargeCandidates.length === 0 || this.editMode,
        onClick: () => this.toggle('ToggleActiveChargeCandidates', 'Toggle Active on Charge candidates', 'You are about to toggle Active on selected')
      }]
    });
    this.actionBar.push({
      label: this.translateService.instant('Laid-Up'),
      items: [{
        label: () => this.translateService.instant('Laid-Up From'),
        icon: 'hourglass-start',
        isVisible: () => !this.createMode,
        isDisabled: () => !this.isBillable || this.laidUpBegan || this.editMode,
        onClick: () => this.layUp(EventTypeCodes.LaidUpFrom, 'From')
      }, {
        label: () => this.translateService.instant('Laid-Up To'),
        icon: 'hourglass-end',
        isVisible: () => !this.createMode,
        isDisabled: () => !this.isBillable || !this.laidUpBegan || this.laidUpCompleted || this.editMode,
        onClick: () => this.layUp(EventTypeCodes.LaidUpTo, 'To')
      }]
    });
    // Set title and breadcrumb
    const source = this.model.mswVisitNumber ? 'msw' : 'vts';
    this.visitSource = {
      lowercase: source,
      uppercase: source.toUpperCase()
    };
    this.parentRoute = `/${this.visitSource.lowercase}-vessel-visit`;
    this.breadcrumb = [{
      icon: 'list',
      title: this.translateService.get(`${this.visitSource.uppercase} Vessel Visit List`),
      route: `/${this.visitSource.lowercase}-vessel-visit/list`
    }, {
      icon: 'ship',
      title: this.translateService.get(`${this.visitSource.uppercase} Visit`)
    }];
    this.personsOnBoard.push({
      disembarkingPassengers: this.model.passengers.filter(p => p.notificationTypeCode === 'A' && p.transit === false)[0]?.total ?? 0,
      embarkingPassengers: this.model.passengers.filter(p => p.notificationTypeCode === 'D' && p.transit === false)[0]?.total ?? 0,
      transitingPassengers: this.model.passengers.filter(p => !p.notificationTypeCode && p.transit === true)[0]?.total ?? 0,
      crew: this.model.crew?.total ?? 0
    });
    // Disable app-controls
    // Angular change detection workaround
    setTimeout(() => {
      super.disableAppControls(this.appControls.filter(control => control.property !== 'attachments'));
    });
    // Set primary permits
    this.primaryVesselPermits = this.model.permits?.filter(permit => !permit.primaryPermitId);
    // Set filters
    this.filterChargeCandidates(this.chargeCandidateFilters[this.toggleableFilter?.activeIndex]?.filters);
    this.events = this.model.vtsEvents.filter(x => !x.discarded);
  }
  vesselVisitCompleted() {
    return this.model.archived || [VesselVisitStatusCodes.Completed, VesselVisitStatusCodes.Closed, VesselVisitStatusCodes.NonBillable].includes(this.model?.statusId);
  }
  generateCandidates() {
    this.dialogService.confirm(this.translateService.instant('Generate'), `${this.translateService.instant(`Are you sure you want to generate charge candidates for `)}${this.title}?`).then(result => {
      if (result !== true) return;
      this.breezeViewService.handleCommand('GenerateChargeCandidates', {
        id: this.model.id
      }).then(() => {
        super.fetch().then(() => this.filterChargeCandidates(this.chargeCandidateFilters[this.toggleableFilter?.activeIndex]?.filters));
      }).catch(err => super.handleError(err));
    });
  }
  toggle(command, title, body) {
    var _superprop_getHandleSingleError = () => super.handleSingleError,
      _this = this;
    this.dialogService.confirm(title, `${body} (${this.selectedChargeCandidates.length}) Charge candidates.`).then( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(function* (result) {
        if (result !== true) return;
        return _this.breezeViewService.handleCommand(command, {
          chargeCandidateIds: _this.selectedChargeCandidates
        }).then(res => {
          if (res?.length > 0) _superprop_getHandleSingleError().call(_this, res[0]);
          _this.selectedChargeCandidates = [];
          _this.fetch().then(() => _this.filterChargeCandidates(_this.chargeCandidateFilters[_this.toggleableFilter?.activeIndex]?.filters));
        });
      });
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  }
  eventHasAnyChargeCandidates(vtsEventId) {
    return this.model.chargeCandidates?.filter(candidate => candidate.vtsEventId === vtsEventId).length > 0;
  }
  permitHasAnyChargeCandidates(vesselPermitId) {
    return this.model.chargeCandidates?.filter(candidate => candidate.vesselPermitId === vesselPermitId).length > 0;
  }
  filterChargeCandidates(filters = null) {
    this.displayedChargeCandidates = this.model?.chargeCandidates.filter(candidate => !filters || filters.includes(candidate.serviceId));
    // Update notifications
    this.chargeCandidateFilters.forEach(filter => {
      if (filter.filters) {
        filter.notifications = this.model.chargeCandidates.filter(cc => !cc.invoiceItemId && cc.active && filter.filters?.includes(cc.serviceId)).length;
      } else {
        filter.notifications = this.model.chargeCandidates.filter(cc => !cc.invoiceItemId && cc.active).length;
      }
    });
  }
  createInvoice() {
    this.router.navigate(['/invoice/create/'], {
      state: {
        data: {
          action: 'vtsVesselVisitCreateInvoice',
          route: this.router.url,
          vesselVisitId: this.model.id,
          voyageNumber: this.model.mswVisitNumber ?? this.model.visitNumber,
          ata: this.model.ata,
          vesselId: this.model.vesselId,
          vesselRevisionId: this.model.vesselRevisionId,
          berthId: this.model.berthId,
          customerId: this.model.agent.customerId
        }
      }
    });
  }
  addExistingInvoice() {
    var _this2 = this;
    return _asyncToGenerator(function* () {
      const modalRef = _this2.breezeViewService.openModal(AddExistingInvoiceModalComponent, {
        size: 'xl'
      });
      modalRef.componentInstance.vtsVesselVisitId = _this2.model.id;
      return modalRef.result.then(() => _this2.fetch());
    })();
  }
  charge() {
    var _this3 = this;
    return _asyncToGenerator(function* () {
      const modalRef = _this3.breezeViewService.openModal(NmswChargeCandidatesModalComponent, {
        size: 'xl',
        windowClass: 'extra-large-modal'
      });
      modalRef.componentInstance.vtsVesselVisitId = _this3.model.id;
      modalRef.componentInstance.chargeCandidateSelection = _this3.selectedChargeCandidates;
      return modalRef.result.then(invoiceIds => {
        if (!invoiceIds) return;
        if (invoiceIds.length > 1) {
          _this3.toastrService.info('Multiple invoices created');
          _this3.fetch();
        } else {
          _this3.router.navigate([`/invoice/view/${typeof invoiceIds === 'number' ? invoiceIds : invoiceIds[0]}`], {
            state: {
              data: {
                action: 'vtsVesselVisitCreateAutoInvoice'
              }
            }
          });
        }
      });
    })();
  }
  noBill() {
    var _superprop_getHandleSingleError2 = () => super.handleSingleError,
      _this4 = this;
    return _asyncToGenerator(function* () {
      _this4.dialogService.confirm(`Complete ${_this4.title}`, `You are about to mark MSW Vessel Visit as Non-Billable. This will delete any Invoice Drafts, deactivate any active Charge candidates, prevent further workflow actions and Charge candidates from being generated. This action is irreversible.`).then( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(function* (result) {
          if (result !== true) return;
          return _this4.breezeViewService.handleCommand('NoBillVtsVesselVisits', {
            ids: [_this4.model.id]
          }).then(res => {
            if (res?.length > 0) _superprop_getHandleSingleError2().call(_this4, res[0]);
            _this4.fetch();
          });
        });
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    })();
  }
  complete() {
    var _superprop_getHandleSingleError3 = () => super.handleSingleError,
      _this5 = this;
    return _asyncToGenerator(function* () {
      _this5.dialogService.confirm(`Complete ${_this5.title}`, `You are about to Complete MSW Vessel Visit. This action will prevent further Charge candidates from being generated and is irreversible.`).then( /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(function* (result) {
          if (result !== true) return;
          return _this5.breezeViewService.handleCommand('CompleteVtsVesselVisits', {
            ids: [_this5.model.id]
          }).then(res => {
            if (res?.length > 0) _superprop_getHandleSingleError3().call(_this5, res[0]);
            _this5.fetch();
          });
        });
        return function (_x3) {
          return _ref3.apply(this, arguments);
        };
      }());
    })();
  }
  archive() {
    var _superprop_getHandleSingleError4 = () => super.handleSingleError,
      _this6 = this;
    return _asyncToGenerator(function* () {
      _this6.dialogService.confirm(`Archive ${_this6.title}`, `You are about to send MSW Vessel Visit to the Archive. <b>This action is irreversible.</b>`).then( /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator(function* (result) {
          if (result !== true) return;
          return _this6.breezeViewService.handleCommand('ArchiveVtsVesselVisits', {
            ids: [_this6.model.id]
          }).then(res => {
            if (res?.length > 0) _superprop_getHandleSingleError4().call(_this6, res[0]);
            _this6.fetch();
          });
        });
        return function (_x4) {
          return _ref4.apply(this, arguments);
        };
      }());
    })();
  }
  layUp(eventTypeId, titleAddition) {
    var _superprop_getExecuteAndHandle = () => super.executeAndHandle,
      _this7 = this;
    return _asyncToGenerator(function* () {
      const data = yield _this7.dialogService.form({
        title: `Lay-Up ${titleAddition}`,
        message: `${titleAddition === 'From' ? `You are about to enter a Laid-Up From Event into the ${_this7.visitSource.uppercase} Vessel Visit's Vessel Events. If they exist, this will deactivate all later Port Due Charge Candidates which are not yet invoiced and will prevent further Port Due Charge Candidates from being generated while the ${_this7.visitSource.uppercase} Vessel Visit is Laid-Up.` : `You are about to enter a Laid-Up To Event into the ${_this7.visitSource.uppercase} Vessel Visit's Vessel Events. This will prevent further Laid-Up due Charge Candidates from being generated and if eligible, will trigger further generation of Port Due Charge candidates.`}`,
        properties: [{
          name: 'eventTime',
          type: AppControlType.DateTime,
          time: true,
          label: `Lay-Up ${titleAddition}`,
          initialValue: new Date()
        }],
        canConfirm: model => model.eventTime
      }, {
        size: 'md'
      });
      if (!data) return;
      _superprop_getExecuteAndHandle().call(_this7, 'AddVtsEventToVisit', 'Lay-Up', {
        vtsVesselVisitId: _this7.model.id,
        eventTypeId: eventTypeId,
        eventTime: data.eventTime
      }, true);
    })();
  }
  setBookmarkColor(entityColor) {
    var _superprop_getHandleSingleError5 = () => super.handleSingleError,
      _this8 = this;
    return _asyncToGenerator(function* () {
      return _this8.breezeViewService.handleCommand('SetVtsVesselVisitsColor', {
        ids: [_this8.model.id],
        colorId: entityColor.colorId
      }).then(res => {
        if (res?.length > 0) _superprop_getHandleSingleError5().call(_this8, res[0]);
        _this8.fetch();
      });
    })();
  }
  applyVesselRevision(vesselRevisionId) {
    var _this9 = this;
    return _asyncToGenerator(function* () {
      _this9.executeAndHandle('ApplyVesselRevisionToVtsVesselVisit', null, {
        vesselRevisionId: vesselRevisionId
      }, true);
    })();
  }
}
NmswVesselVisitViewComponent.ɵfac = function NmswVesselVisitViewComponent_Factory(t) {
  return new (t || NmswVesselVisitViewComponent)(i0.ɵɵdirectiveInject(i1.BreezeViewService), i0.ɵɵdirectiveInject(i2.DialogService));
};
NmswVesselVisitViewComponent.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
  type: NmswVesselVisitViewComponent,
  selectors: [["app-nmsw-vessel-visit-view"]],
  viewQuery: function NmswVesselVisitViewComponent_Query(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵviewQuery(ToggleableFilterComponent, 5);
    }
    if (rf & 2) {
      let _t;
      i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.toggleableFilter = _t.first);
    }
  },
  inputs: {
    vtsVesselVisit: "vtsVesselVisit"
  },
  features: [i0.ɵɵProvidersFeature([BreezeViewService]), i0.ɵɵInheritDefinitionFeature],
  decls: 25,
  vars: 2,
  consts: [[3, "items", 4, "ngIf"], [3, "isBusy"], ["tab0Content", ""], ["tab1Content", ""], ["tab2Content", ""], ["tab3Content", ""], ["tab4Content", ""], ["tab5Content", ""], ["tab6Content", ""], ["tab7Content", ""], ["tab8Content", ""], ["tab9Content", ""], ["tab10Content", ""], [3, "items"], [3, "title", "breadcrumb", "compacted"], ["entity", "VtsVesselVisit", 3, "entityId", "color", "disabled", "setColor"], ["class", "ml-2", 3, "vesselRevisions", "applyVesselRevision", 4, "ngIf"], [1, "card", "card-border-top"], [1, "card-body"], [1, "row"], [1, "col"], ["type", "codelist", "codelist", "Vessel", "property", "vesselId", 3, "label", "ngModel", "entity", "ngModelChange", 4, "ngIf", "ngIfElse"], ["vtsVesselId", ""], ["format", "#", "property", "iMONumber", 3, "label", "ngModel", "entity", "ngModelChange", 4, "ngIf", "ngIfElse"], ["vtsVesselImo", ""], ["type", "codelist", "codelist", "Port", "property", "portId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Berth", "property", "berthId", 3, "label", "ngModel", "entity", "ngModelChange"], ["property", "ata", 3, "label", "time", "ngModel", "entity", "ngModelChange"], ["property", "atd", 3, "label", "time", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Country", "property", "countryId", 3, "label", "ngModel", "entity", "ngModelChange", 4, "ngIf", "ngIfElse"], ["vtsVesselCountry", ""], ["type", "codelist", "codelist", "Port", "property", "lastPortId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Port", "property", "nextPortId", 3, "label", "ngModel", "entity", "ngModelChange"], ["format", "n3", "property", "grossTonnage", 3, "label", "decimals", "ngModel", "entity", "ngModelChange", 4, "ngIf"], ["format", "n3", "property", "netTonnage", 3, "label", "ngModel", "entity", "ngModelChange", 4, "ngIf"], ["property", "length", 3, "label", "ngModel", "entity", "ngModelChange", 4, "ngIf", "ngIfElse"], ["vtsVesselLength", ""], [1, "col-2"], ["codelist", "Organization", "property", "agentId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Organization", "property", "additionalAgents", 3, "label", "multi", "ngModel", "entity", "ngModelChange"], ["codelist", "VtsCallPurpose", "property", "vtsCallPurposeId", 3, "label", "ngModel", "entity", "ngModelChange"], ["codelist", "CallActivity", "property", "callActivityId", 3, "label", "ngModel", "entity", "ngModelChange"], [1, "col-4"], ["type", "codelist", "codelist", "VtsCallPurpose", "property", "callPurposes", 3, "label", "multi", "ngModel", "entity", "ngModelChange"], ["property", "mswVisitNumber", 3, "label", "ngModel", "entity", "ngModelChange"], ["property", "visitNumber", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "VesselVisitStatus", "property", "statusId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "VesselType", "property", "typeId", 3, "label", "ngModel", "entity", "ngModelChange", 4, "ngIf", "ngIfElse"], ["vtsVesselType", ""], ["property", "arrivalCallPurposeRemarks", 3, "label", "ngModel", "entity", "ngModelChange"], ["property", "departureRemarks", 3, "label", "ngModel", "entity", "ngModelChange"], [1, "col-md-auto"], ["type", "boolean", "property", "isShort", 3, "label", "ngModel", "entity", "ngModelChange"], [1, "mt-3", 3, "tabSelect"], ["tabStrip", ""], [3, "title", "selected"], ["kendoTabContent", ""], [1, "ml-2", 3, "vesselRevisions", "applyVesselRevision"], ["type", "codelist", "codelist", "Vessel", "property", "vesselId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "VtsVessel", "property", "vtsVesselId", 3, "label", "ngModel", "entity", "ngModelChange"], ["format", "#", "property", "iMONumber", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Country", "property", "countryId", 3, "label", "ngModel", "entity", "ngModelChange"], ["format", "n3", "property", "grossTonnage", 3, "label", "decimals", "ngModel", "entity", "ngModelChange"], ["format", "n3", "property", "netTonnage", 3, "label", "ngModel", "entity", "ngModelChange"], ["property", "length", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "VesselType", "property", "typeId", 3, "label", "ngModel", "entity", "ngModelChange"], [4, "ngTemplateOutlet"], [3, "data", "sort", "sortable"], ["field", "id", 3, "title", "hidden"], ["field", "typeId", 3, "title"], ["kendoGridCellTemplate", ""], ["field", "eventTime", "format", "g", 3, "title"], ["field", "lastPortId", 3, "title"], ["field", "lastAreaId", 3, "title", "sortable"], ["field", "nextAreaId", 3, "title", "sortable"], ["field", "nextPortId", 3, "title"], ["field", "shiftCallPurposeId", 3, "title"], ["field", "serviceVessel.name", 3, "title"], ["field", "hasCandidate", "width", "160", 3, "title"], ["field", "cancelledOperationReason", "width", "160", 3, "title"], ["field", "remarks", 3, "title"], ["field", "shiftRemarks", 3, "title"], [4, "ngIf", "ngIfElse"], ["revisedEvent", ""], [3, "code", "floating"], ["lastBerth", ""], ["nextBerth", ""], [3, "check"], [3, "data"], ["field", "portOfLoadingId", 3, "title"], ["field", "portOfDischargeId", 3, "title"], ["field", "manifestCargoTypeId", 3, "title"], ["field", "commodityId", 3, "title"], ["field", "netWeight", 3, "title"], ["field", "grossWeight", 3, "title"], ["field", "quantity", 3, "title"], ["field", "unitOfMeasurementId", 3, "title"], ["field", "packagingTypeId", 3, "title"], ["field", "imdgClassId", 3, "title"], ["field", "notificationTypeCode", 3, "title"], ["field", "wasteTypeId", 3, "title"], ["field", "disembarkingPassengers", 3, "title"], ["field", "embarkingPassengers", 3, "title"], ["field", "transitingPassengers", 3, "title"], ["field", "crew", 3, "title"], [3, "data", "sortable", "sort"], ["field", "referenceNumber", 3, "title"], ["field", "permitTypeId", 3, "title"], ["field", "permitStatusId", 3, "title"], ["field", "requestingOrganizationId", 3, "title"], ["field", "berthId", 3, "title"], ["field", "approvalDate", "format", "g", 3, "title"], ["field", "validFromDate", "format", "g", 3, "title"], ["field", "validToDate", "format", "g", 3, "title"], ["field", "hasCandidate", 3, "title"], ["kendoGridDetailTemplate", ""], ["target", "_blank", 1, "text-primary", "link-box", "fixed", 3, "href"], ["icon", "arrow-up-right-from-square"], [1, "text-primary", "link-box", 3, "routerLink"], [3, "primaryPermitId"], [3, "filters", "filterToggled"], ["entityName", "ChargeCandidate", 3, "data", "selectable", "selectBy", "sort", "editMode", "canAddNew", "canDelete", "selection", "selectionChange"], ["showSelectAll", "true", "width", "1px", 4, "ngIf"], ["field", "serviceId", "width", "125px", 3, "title"], ["field", "description", "width", "260px", 3, "title"], ["field", "invoiceItemId", "width", "70px", 3, "title"], ["field", "from", "format", "g", "width", "190px", 3, "title"], ["kendoGridEditTemplate", ""], ["field", "to", "format", "g", "width", "190px", 3, "title"], ["field", "total", "width", "150px", 3, "title"], ["field", "createdById", "width", "170px", 3, "title"], ["field", "createdDate", "format", "g", "width", "155px", 3, "title"], ["field", "lastModifiedById", "width", "170px", 3, "title"], ["field", "lastModifiedDate", "format", "g", "width", "155px", 3, "title"], ["field", "doubleRate", "width", "40px", 3, "title"], ["field", "active", "width", "40px", 3, "title"], ["showSelectAll", "true", "width", "1px"], [3, "check", "neutral"], ["type", "datetime", "property", "from", 3, "time", "isDisabled", "ngModel", "entity", "ngModelChange"], ["type", "datetime", "property", "to", 3, "time", "isDisabled", "ngModel", "entity", "ngModelChange"], ["type", "number", "property", "total", 3, "isDisabled", "ngModel", "entity", "ngModelChange"], ["type", "boolean", "size", "lg", "property", "doubleRate", 3, "isDisabled", "ngModel", "entity", "ngModelChange"], ["type", "boolean", "size", "lg", "property", "active", 3, "isDisabled", "ngModel", "entity", "ngModelChange"], [3, "editMode", "items"], [1, "row", "mt-4"], ["translate", ""], ["field", "voltage", 3, "title"], ["field", "frequency", 3, "title"], ["field", "shoreIdentification", 3, "title"], ["field", "terminalId", 3, "title"], ["field", "totalEnergy", 3, "title"], ["field", "connectionTimestamp", "format", "g", 3, "title"], ["field", "disconnectionTimestamp", "format", "g", 3, "title"], ["field", "timeStamp", "format", "g", 3, "title"], ["field", "deltaEnergy", 3, "title"], ["type", "file", "property", "attachments", 3, "multiple", "editMode", "ngModel", "entity", "ngModelChange", "addFile"], ["files", ""], [3, "items", "editMode"], ["field", "id", 3, "width", "title"], ["field", "createdDate", "format", "g", 3, "width", "title"], ["field", "dateAppliedToVisit", "format", "g", 3, "width", "title"], ["field", "name", "pattern", "[\\w\\d\\s\\.\\-\\']", 3, "width", "title"], ["field", "countryId", 3, "width", "title"], ["field", "typeId", 3, "width", "title"], ["field", "netTonnage", "format", "n3", 3, "width", "title"], ["field", "grossTonnage", "format", "n3", 3, "width", "title"], ["field", "length", "format", "n3", 3, "width", "title"], ["codelist", "Country", 3, "code", "floating"]],
  template: function NmswVesselVisitViewComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵtemplate(0, NmswVesselVisitViewComponent_app_action_bar_0_Template, 1, 1, "app-action-bar", 0);
      i0.ɵɵelementStart(1, "app-loader", 1);
      i0.ɵɵtemplate(2, NmswVesselVisitViewComponent_ng_template_2_Template, 120, 152, "ng-template");
      i0.ɵɵelementEnd();
      i0.ɵɵtemplate(3, NmswVesselVisitViewComponent_ng_template_3_Template, 35, 45, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
      i0.ɵɵtemplate(5, NmswVesselVisitViewComponent_ng_template_5_Template, 38, 41, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
      i0.ɵɵtemplate(7, NmswVesselVisitViewComponent_ng_template_7_Template, 8, 11, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
      i0.ɵɵtemplate(9, NmswVesselVisitViewComponent_ng_template_9_Template, 9, 13, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
      i0.ɵɵtemplate(11, NmswVesselVisitViewComponent_ng_template_11_Template, 31, 37, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
      i0.ɵɵtemplate(13, NmswVesselVisitViewComponent_ng_template_13_Template, 40, 47, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
      i0.ɵɵtemplate(15, NmswVesselVisitViewComponent_ng_template_15_Template, 1, 2, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor);
      i0.ɵɵtemplate(17, NmswVesselVisitViewComponent_ng_template_17_Template, 20, 22, "ng-template", null, 9, i0.ɵɵtemplateRefExtractor);
      i0.ɵɵtemplate(19, NmswVesselVisitViewComponent_ng_template_19_Template, 2, 4, "ng-template", null, 10, i0.ɵɵtemplateRefExtractor);
      i0.ɵɵtemplate(21, NmswVesselVisitViewComponent_ng_template_21_Template, 1, 2, "ng-template", null, 11, i0.ɵɵtemplateRefExtractor);
      i0.ɵɵtemplate(23, NmswVesselVisitViewComponent_ng_template_23_Template, 22, 39, "ng-template", null, 12, i0.ɵɵtemplateRefExtractor);
    }
    if (rf & 2) {
      i0.ɵɵproperty("ngIf", !ctx.cardView);
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("isBusy", !ctx.model);
    }
  },
  dependencies: [i3.NgIf, i3.NgTemplateOutlet, i4.RouterLink, i5.NgControlStatus, i5.NgModel, i6.FaIconComponent, i7.TranslateDirective, i8.ColumnComponent, i8.DetailTemplateDirective, i8.CheckboxColumnComponent, i8.CellTemplateDirective, i8.EditTemplateDirective, i9.TabStripComponent, i9.TabStripTabComponent, i9.TabContentDirective, i10.ActionBarComponent, i11.AppControlComponent, i12.LoaderComponent, i13.ContentLinkHeaderComponent, i14.AppGridComponent, i15.NoteListComponent, i16.EditableGridComponent, i17.FlagIconComponent, i18.CheckIconComponent, i19.ToggleableFilterComponent, i20.PopoverListComponent, i21.BookmarkComponent, i22.InvoiceListComponent, i23.VesselPermitDetailComponent, i24.VesselRevisionChangeApplicatorComponent, i3.AsyncPipe, i3.DecimalPipe, i7.TranslatePipe, i25.CodelistPipe],
  styles: ["\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsInNvdXJjZVJvb3QiOiIifQ== */"]
});